/**
 * Default tags available for support cases
 */
export const DEFAULT_TAGS = [
  'Additional Resources',
  'Application Issue',
  'Eligibility',
  'Liveness Issue',
  'Payment',
  'Recollect'
];

/**
 * Get initials from a user name string
 * @param str - User name string (may include browser tab after /)
 * @returns Initials (e.g., "John Doe" -> "JD")
 */
export const getInitials = (str: string): string => {
  if (str) {
    return str
      .split('/')[0]
      .split(' ')
      .filter((v: string) => v)
      .map((w: string) => w[0])
      .join('');
  }
  return '';
};

/**
 * Determine the application stage from an applicant UID
 * @param uid - Applicant UID
 * @param localization - Localization object with application_stage strings
 * @returns Localized stage string
 */
export const getStageFromUid = (
  uid: string | undefined,
  localization: { pre_application: string; applied: string; in_progress: string }
): string => {
  if (!uid) return localization.pre_application;
  // Length <= 22 means it's an ingested UID
  if (uid.length <= 22) return localization.applied;
  return localization.in_progress;
};

/**
 * Get display name for an assignee, adding "(AidKit)" suffix for internal employees
 * @param assignee - Assignee object with uid, name, and email
 * @returns Display name with optional (AidKit) suffix
 */
export const getAssigneeDisplayName = (assignee: { uid: string; name: string; email: string }): string => {
  if (!assignee.email || !(assignee.email.includes('@aidkit.org') || assignee.email.includes('@aidkit.cloud'))) {
    return assignee.name;
  }

  return `${assignee.name} (AidKit)`;
};
